import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '@/components/common/Dropdown/Dropdown';
import {
  defaultStyle,
  disabledStyle,
  errorStyle,
} from '@/components/common/Select/SelectConfig';
import '@/components/common/CommonStyle.scss';
import { useMixedPlaceholder } from '@/hooks/useMixedPlaceholder';

const Artist = ({
  index,
  item,
  errorBanner,
  handleChange,
  inputs,
  inputCustomClass,
  dropdownCustomClass,
  handleDeleteInput,
  handleAddInput,
  handleRoleAndSequenceChange,
  artistRole,
  disabled,
  mixedPlaceholder,
  onFocusName,
  onFocusRole,
  metadataConflictErrorMessage,
}: any) => {
  const [onClickArtistName, setOnClickArtistName] = useState(false);
  const [onClickArtistRole, setOnClickArtistRole] = useState(false);
  const [onChangeArtistName, setOnChangeArtistName] = useState(false);
  const [onChangeArtistRole, setOnChangeArtistRole] = useState(false);
  const [role, setRole] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    setRole(artistRole.find((x: any) => x.label === item.performerRole));
  }, [item.performerRole, artistRole]);
  const nameError: boolean =
    onClickArtistName && !onChangeArtistName && !item.name;
  const roleError: boolean =
    onClickArtistRole && !onChangeArtistRole && !item.performerRole;
  const checkDelete: boolean =
    inputs.length > 1 ||
    (inputs.length === 1 &&
      inputs[0].performerRole !== null &&
      inputs[0].performerRole !== '');
  const showDropdown = artistRole && artistRole.length > 1;
  const showMetadataConflictPopup =
    Boolean(metadataConflictErrorMessage) &&
    !disabled &&
    (onClickArtistName || onClickArtistRole);
  const isMixedDisabled = () => {
    return (
      disabled && (item?.performerRole === 'Mixed' || item?.name === 'Mixed')
    );
  };

  const getInputClassName = useCallback(() => {
    let className =
      metadataConflictErrorMessage ||
      (!item.name && !disabled && !onChangeArtistName && errorBanner)
        ? 'form-control invalid-input'
        : 'form-control';
    if (inputCustomClass) {
      className += ` ${inputCustomClass}`;
    }
    return className;
  }, [
    item.name,
    disabled,
    onChangeArtistName,
    errorBanner,
    inputCustomClass,
    metadataConflictErrorMessage,
  ]);

  const getDropdownClassName = useCallback(() => {
    return dropdownCustomClass
      ? `float-end ${dropdownCustomClass}`
      : 'float-end';
  }, [dropdownCustomClass]);

  const artistMixedPlaceholder = useMixedPlaceholder(mixedPlaceholder, {
    onFocus: () => {
      setOnClickArtistName(true);
      if (onFocusName) {
        onFocusName();
      }
    },
    onBlur: () => {
      setOnClickArtistName(false);
    },
    onClick: () => {
      setOnClickArtistName(true);
    },
  });

  return (
    <>
      <div id={index} className={'col-sm-12 list-item'}>
        <div className="pair-input contributor-input">
          <div className={showDropdown ? 'float-start' : ''}>
            <input
              type="text"
              className={getInputClassName()}
              id="artistName"
              value={item.name}
              onChange={(e) => {
                setOnChangeArtistName(true);
                handleChange(e, index, 'name');
              }}
              {...artistMixedPlaceholder}
              disabled={disabled}
            />
          </div>
          {showDropdown && (
            <div className={getDropdownClassName()}>
              <Dropdown
                id="artistRole"
                placeholder={
                  item.performerRole === 'Mixed' ? t('track.mixed') : null
                }
                options={artistRole}
                selectedOption={item.performerRole !== 'Mixed' ? role : ''}
                onOptionChange={(e: any) => {
                  handleRoleAndSequenceChange(e, index);
                  setOnChangeArtistRole(true);
                }}
                isClearable={false}
                style={
                  disabled
                    ? disabledStyle
                    : metadataConflictErrorMessage ||
                        (!item.performerRole &&
                          !onChangeArtistRole &&
                          errorBanner)
                      ? errorStyle
                      : defaultStyle
                }
                onFocus={() => {
                  setOnClickArtistRole(true);
                  if (onFocusRole) {
                    onFocusRole();
                  }
                }}
                onBlur={() => {
                  setOnClickArtistRole(false);
                }}
                disabled={disabled}
              ></Dropdown>
            </div>
          )}
        </div>
        {(checkDelete && !disabled) || isMixedDisabled() ? (
          <button
            className="icon-btn"
            onClick={() => handleDeleteInput(index)}
            type="button"
          >
            <i className="icon fas fa-times"></i>
          </button>
        ) : null}
      </div>
      {showMetadataConflictPopup ||
      (errorBanner && !disabled && (nameError || roleError)) ? (
        <div
          className={`${showMetadataConflictPopup ? 'col-sm-6' : 'col-sm-3 artist-required-error-popup'} popUp-container`}
        >
          {showMetadataConflictPopup
            ? metadataConflictErrorMessage
            : nameError
              ? t('validationAlert.nameRequired.ErrorMessage')
              : roleError
                ? t('validationAlert.roleRequired.ErrorMessage')
                : null}
        </div>
      ) : null}
      {index === inputs.length - 1 &&
        (!disabled || isMixedDisabled() ? (
          <div className="col-sm-12 text-start">
            <button
              type="button"
              className="btn add-btn text-end"
              onClick={() => {
                handleAddInput();
              }}
              disabled={isMixedDisabled()}
            >
              <i className="icon fas fa-plus"></i>
              <span>{t('common.button.addArtist')}</span>
            </button>
          </div>
        ) : null)}
    </>
  );
};
export default Artist;
